import { RootState } from "@/modules/common";

export const selectIsProductInBasket = (id: string) => (state: RootState) =>
  state.basket.basket.products.some(x => x.productId === id);
